module.exports = __webpack_public_path__ + "img/bg_mobile.b1e03cfd.png";